import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ElementCreateButton from './ElementCreateButton';
import PopupPanel from '../../../components/popupPanel/PopupPanel';

import { createAndEditElement } from '../../../element/actions/elementActions';
import { closePopup } from '../../../components/popupPanel/popupActions';

import { getElementDisplayName } from '../../../../common/elements/elementRegistry';

import './ElementCreatePopup.scss';
import { PopupIds } from '../../../components/popupPanel/popupConstants';
import { ElementType } from '../../../../common/elements/elementTypes';

const mapDispatchToProps = (dispatch) => ({
    dispatchCreateElement: ({ elementType, location }) =>
        dispatch(
            createAndEditElement({
                elementType,
                location,
                select: true,
            }),
        ),
    dispatchClosePopup: () => dispatch(closePopup()),
});

const ElementCreatePopup = (props) => (
    <PopupPanel popupId={PopupIds.ELEMENT_CREATE} {...props} className="ElementCreatePopup" arrowDir="bottom" padded>
        <ul className="button-list">
            <ElementCreateButton
                {...props}
                elementType={ElementType.CARD_TYPE}
                name={getElementDisplayName(ElementType.CARD_TYPE)}
            />
            <ElementCreateButton
                {...props}
                elementType={ElementType.LINK_TYPE}
                name={getElementDisplayName(ElementType.LINK_TYPE)}
            />
            <ElementCreateButton
                {...props}
                elementType={ElementType.IMAGE_TYPE}
                name={getElementDisplayName(ElementType.IMAGE_TYPE)}
            />
        </ul>
    </PopupPanel>
);

ElementCreatePopup.propTypes = {
    dispatchCreateElement: PropTypes.func,
    dispatchClosePopup: PropTypes.func,
    currentBoardId: PropTypes.string,
};

export default connect(null, mapDispatchToProps)(ElementCreatePopup);
